import React from "react"
import * as styles from "./cv.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons"
import { faCheck } from "@fortawesome/free-solid-svg-icons"

const Cv = ({ img, title, point, score, url }) => {
  return (
    <div className={styles.reviewBoxLine}>
      <p className={styles.reviewBox_title1}>ボードゲームのスコア</p>
      <div className={styles.reviewBox_content}>
        <div className={styles.reviewBox_top}>
          <div className={styles.reviewBox_left}>
            <p className={styles.reviewBox_title2}>{title}</p>
            {point.map((node, index) => {
              return (
                <p key={index}>
                  <FontAwesomeIcon icon={faCheck} className="mr-1" />
                  {node}
                </p>
              )
            })}
          </div>
          <div className={styles.reviewBox_right}>
            <img src={img} alt={title} />
          </div>
        </div>
        <div className={styles.reviewBox_center}>
          <div className={styles.score}>
            {score.map((node, index) => {
              return (
                <div className={styles.score_content} key={index}>
                  <div className={styles.score_left}>
                    <div className={styles.score_text}>{node[0]}</div>
                    <div
                      className={`${styles.score_line} ${
                        styles[`score_line_${node[1]}`]
                      }`}
                    ></div>
                  </div>
                  <div className={styles.score_num}>{node[1]}</div>
                </div>
              )
            })}
          </div>
        </div>
        <div>
          <div className={styles.reviewLink}>
            <a href={url} target="_blank" rel="nofollow noreferrer">
              <FontAwesomeIcon icon={faChevronCircleRight} className="mr-2" />
              公式サイトへ
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cv
